const MapMarkerHtml = ({ location }) => {
  return (
    <div>
      <h3 className="uberall-locations__item-name">
        {location.url ? (
          <a href={location.url} className="uberall-locations__item-link" rel="noopener noreferrer" target="_blank">
            {location.name}
          </a>
        ) : (
          location.name
        )}
      </h3>
      <p className="uberall-locations__map-item-address">
        <div className="uberall-locations__map-item-city-zip">
          {location.zip} {location.city}
        </div>
        <div className="uberall-locations__map-item-street-address">{location.address}</div>
        {location.addressExtra && (
          <div className="uberall-locations__map-item-address-extra">{location.addressExtra}</div>
        )}
      </p>
      <div className="uberall-locations__map-item-actions">
        {location.googleRouteUrl && (
          <a href={location.googleRouteUrl} className="btn btn--primary uberall-locations__map-item-btn uberall-locations__map-item-btn--route" target="_blank" rel="noopener noreferrer">
            <svg xmlns="http://www.w3.org/2000/svg" height="48px" viewBox="0 -960 960 960" width="48px" fill="currentColor"><path d="M360-160v-298q0-12.09 5-23.04Q370-492 378-500l240-240H491v-60h229v229h-60v-127L420-458v298h-60Z"/></svg>
            Route
          </a>
        )}
        {location.url && (
          <a href={location.url} className="btn btn--primary uberall-locations__map-item-btn uberall-locations__map-item-btn--details" target="_blank">
            Details
          </a>
        )}
      </div>
    </div>
  );
};

export default MapMarkerHtml;
